import React from 'react';
import classNames from 'classnames';
import {Link} from 'react-router';
import formatDate from 'utils/formatDate';
import './BasedOnDatesLink.styl';

export default class BasedOnDatesLink extends React.PureComponent {
  render() {
    const {startDate, endDate, location, className = ''} = this.props;
    if (!startDate || !location) {
      console.warn('One of these is null', startDate, location);
      // GIGO, better than dying with a console error
      return null;
    }
    const label = `Between ${formatDate(startDate)} and ${formatDate(endDate).toLowerCase()}`;

    const state = {blinkDates: true};

    return (
      <Link
        to={{
          pathname: location.pathname,
          query: location.query,
          state,
        }}
        className={classNames('generic-link', 'based-on-dates', className)}>
        {label}
      </Link>
    );
  }
}
